import styled from 'styled-components';

import { FontWeight, Margin } from '@demandstar/components/styles';

export const FooterLabel = styled.span`
  font-weight: ${FontWeight.Header};
  margin-right: ${Margin.Less};
`;
